<template>
    <Modal v-model="modalRules"
           :title="$t('安全组规则')"
           width="700"
           class="ipList"
           :mask-closable="false"
           @on-cancel="cancel">
        <rcTable v-if="initTableAttr"
                 ref="rcTableRules"
                 :tableAttr="tableAttr">
        </rcTable>
        <div slot="footer">
            <Button @click="cancel">{{$t('关闭')}}</Button>
        </div>
    </Modal>
</template>

<script>
import rcTable from '@c/basic/rcTable'
export default {
    name: 'rules',
    props: ['rulesData', 'envType'],
    components: {
        rcTable
    },
    data () {
        return {
            modalRules: false,
            initTableAttr: false,
            tableAttr: {
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                pageData: {
                    pageWays: 'client'
                },
                searchShow: false,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$t('协议'),
                        key: 'protocol',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            const d = (this.isNullOrUndefined(params.row.protocol) || params.row.protocol === '-1') ? '任何' : params.row.protocol
                            return h('p', { attrs: { title: d }, class: 'rc-ellipsis' }, d)
                        }
                    },
                    {
                        title: this.$t('端口范围'),
                        key: 'toPort',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            let d = '任何'
                            if (!this.isNullOrUndefined(params.row.portRangeMin) && params.row.portRangeMin !== '-1') {
                                d = params.row.portRangeMin + '-' + params.row.portRangeMax
                            } else if (!this.isNullOrUndefined(params.row.fromPort) && params.row.portRangeMin !== '-1') {
                                d = params.row.fromPort + '-' + params.row.toPort
                            }
                            return h('p', { attrs: { title: d }, class: 'rc-ellipsis' }, d)
                        }
                    },
                    {
                        title: this.$t('授权对象'),
                        key: 'instanceName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            let d = ''
                            if (params.row.authObj === '地址段访问') {
                                d = params.row.remoteIpPrefix
                            } else if (params.row.authObj === '安全组访问') {
                                d = params.row.remoteGroupName
                            } else if (!this.isNullOrUndefined(params.row.range)) {
                                d = params.row.range
                            }
                            return h('p', { attrs: { title: d }, class: 'rc-ellipsis' }, d)
                        }
                    },
                    {
                        title: this.$t('方向'),
                        key: 'description',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            let d = ''
                            if (params.row.direction === 'ingress') {
                                d = '入口方向'
                            } else if (params.row.direction === 'egress') {
                                d = '出口方向'
                            }
                            return h('p', { attrs: { title: d }, class: 'rc-ellipsis' }, d)
                        }
                    }
                ]
            }
        }
    },
    watch: {
        rulesData (newVal, oldVal) {
            this.tableAttr.source.tableData.totalRows = 0
            this.tableAttr.source.tableData.dataList = []
            if (newVal && newVal.length > 0) {
                this.tableAttr.source.tableData.totalRows = newVal.length
                this.tableAttr.source.tableData.dataList = newVal
            }
            this.refresh()
        }
    },
    methods: {
        openModal (row) {
            // bug17062openstack系列添加以太网类型
            const data = ['OpenStack', 'OpenStack-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'Nine9Cloud', 'Nine9Cloud-Admin']
            if (data.includes(this.envType)) {
                const columns = {
                    title: this.$t('以太网类型'),
                    key: 'ethertype',
                    columnShow: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.ethertype } }, params.row.ethertype)
                    }
                }
                this.tableAttr.columns.unshift(columns)
            }
            this.modalRules = true
            this.initTableAttr = true
        },
        cancel () {
            this.modalRules = false
            this.initTable()
        },
        refresh () {
            this.$refs.rcTableRules && this.$refs.rcTableRules.refreshTable()
        },
        // 初始化table
        initTable () {
            this.tableAttr.source.tableData.totalRows = 0
            this.tableAttr.source.tableData.dataList = []
            this.tableAttr.columns.splice(0, 1)
        },
        isNullOrUndefined (value) {
            if (value === null || value === undefined || value === 'unrecognized' || value === -1 || !value) {
                return true
            }
            return false
        }
    }
}
</script>
